import { render, staticRenderFns } from "./RouterPage.vue?vue&type=template&id=04242e42&scoped=true"
import script from "./RouterPage.vue?vue&type=script&lang=js"
export * from "./RouterPage.vue?vue&type=script&lang=js"
import style0 from "./RouterPage.vue?vue&type=style&index=0&id=04242e42&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04242e42",
  null
  
)

export default component.exports